import Header from "./Header";
import Footer from "./Footer";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const BlogDetail = () => {
    const { id } = useParams();
    const [post, setPost] = useState(null);
    const [isScrolled, setIsScrolled] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        axios.get(`https://kyrgyz-adventure-travel.com/api/v1/tours/blog/${id}/`)
            .then(response => setPost(response.data))
            .catch(error => console.error("Error loading post: ", error));
    }, [id]);

    useEffect(() => {
        const handleScroll = () => setIsScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    if (!post) return (
        <div className="bg-dark min-h-screen flex items-center justify-center">
            <p className="font-manrope text-white/60">Loading...</p>
        </div>
    );

    return (
        <div className="bg-dark min-h-screen">
            <Header isScrolled={isScrolled} />
            <div className="h-32" />

            <div className="container pb-20 max-w-3xl mx-auto">
                <button
                    onClick={() => navigate('/blog')}
                    className="font-unbounded text-gold text-xs uppercase tracking-widest mb-8 hover:underline flex items-center gap-2"
                >
                    ← Back to Blog
                </button>

                <p className="font-manrope text-white/40 text-sm mb-4">
                    {new Date(post.created_at).toLocaleDateString('en-GB', {
                        day: 'numeric', month: 'long', year: 'numeric'
                    })}
                </p>

                <h1 className="font-unbounded font-bold text-3xl md:text-4xl text-white mb-8">
                    {post.title}
                </h1>

                <p className="font-manrope text-white/70 text-lg leading-relaxed whitespace-pre-line mb-10">
                    {post.content}
                </p>

                {post.images.length === 1 && (
                    <img
                        src={post.images[0].image}
                        alt={post.title}
                        className="w-full h-[500px] object-cover rounded-2xl"
                    />
                )}

                {post.images.length > 1 && (
                    <div className="grid grid-cols-2 gap-3">
                        {post.images.map((img, index) => (
                            <img
                                key={img.id}
                                src={img.image}
                                alt={`${post.title} ${index + 1}`}
                                className={`w-full object-cover rounded-2xl ${index === 0 ? 'col-span-2 h-[500px]' : 'h-72'}`}
                            />
                        ))}
                    </div>
                )}
            </div>

            <Footer />
        </div>
    );
};

export default BlogDetail;
